// import React, { useState, useCallback } from 'react';
// import { 
//   Info, ExternalLink, CheckCircle, AlertTriangle, 
//   Copy, Wallet, ArrowRight, Shield, HelpCircle
// } from 'lucide-react';

// const AddFundsSection = ({ client }) => {
//   const [currentStep, setCurrentStep] = useState('disclaimer');
//   const [agreedToDisclaimer, setAgreedToDisclaimer] = useState(false);
//   const [showTooltip, setShowTooltip] = useState(null);

//   // Copy to clipboard helper
//   const copyToClipboard = useCallback((text, type) => {
//     navigator.clipboard.writeText(text);
//     setShowTooltip(type);
//     setTimeout(() => setShowTooltip(null), 2000);
//   }, []);

//   // Tooltip component
//   const Tooltip = ({ text, type }) => (
//     <div className="relative inline-block ml-2">
//       <button
//         onMouseEnter={() => setShowTooltip(type)}
//         onMouseLeave={() => setShowTooltip(null)}
//         className="text-[#808080] hover:text-[#676DFF] transition-colors"
//       >
//         <HelpCircle className="h-4 w-4" />
//       </button>
//       {showTooltip === type && (
//         <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-[#0A0A0A] border border-[#676DFF]/30 rounded-lg text-xs text-white whitespace-nowrap z-10 shadow-lg">
//           {text}
//           <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-1">
//             <div className="border-4 border-transparent border-t-[#676DFF]/30"></div>
//           </div>
//         </div>
//       )}
//     </div>
//   );

//   const DisclaimerStep = () => (
//     <div className="space-y-6">
//       <div className="bg-[#151515] rounded-2xl border border-[#676DFF]/20 p-6 lg:p-8">
//         <div className="flex items-start gap-4 mb-6">
//           <div className="w-12 h-12 bg-[#676DFF]/10 rounded-full flex items-center justify-center flex-shrink-0">
//             <Shield className="h-6 w-6 text-[#676DFF]" />
//           </div>
//           <div>
//             <h2 className="text-2xl font-semibold text-white mb-2">
//               Important Disclaimer
//             </h2>
//             <p className="text-[#B8B8B8]">
//               Please read carefully before proceeding
//             </p>
//           </div>
//         </div>

//         <div className="space-y-6">
//           <div className="bg-[#0A0A0A] border border-[#505050] rounded-xl p-6 space-y-4">
//             <div className="flex items-start gap-3">
//               <AlertTriangle className="h-5 w-5 text-yellow-400 mt-0.5 flex-shrink-0" />
//               <div className="space-y-3 text-[#B8B8B8] text-sm leading-relaxed">
//                 <p>
//                   <strong className="text-white">Third-Party Service:</strong> This deposit service is provided by PayOnRamp, 
//                   an independent third-party payment processor. AB Nexus acts solely as a facilitator and does not 
//                   process, store, or have access to your payment information.
//                 </p>
//                 <p>
//                   <strong className="text-white">Regulatory Compliance:</strong> By using PayOnRamp, you acknowledge that you 
//                   are subject to their terms of service, privacy policy, and KYC requirements. All transactions must comply 
//                   with applicable Indian laws and regulations.
//                 </p>
//                 <p>
//                   <strong className="text-white">No Financial Advice:</strong> The information provided is for informational 
//                   purposes only and does not constitute financial, investment, or legal advice. You are solely responsible 
//                   for your investment decisions.
//                 </p>
//                 <p>
//                   <strong className="text-white">Risk Acknowledgment:</strong> Cryptocurrency trading involves substantial 
//                   risk of loss. Only invest funds you can afford to lose. Past performance does not guarantee future results.
//                 </p>
//                 <p>
//                   <strong className="text-white">Liability Limitation:</strong> AB Nexus is not liable for any 
//                   issues arising from PayOnRamp's services, including but not limited to payment failures, delays, or disputes. 
//                   Please contact PayOnRamp support directly for payment-related issues.
//                 </p>
//                 <p>
//                   <strong className="text-white">Data Sharing:</strong> Your wallet address will be shared with PayOnRamp 
//                   to facilitate the deposit. No other personal data from our platform is transmitted to PayOnRamp.
//                 </p>
//               </div>
//             </div>
//           </div>

//           <div className="bg-[#676DFF]/10 border border-[#676DFF]/20 rounded-xl p-4">
//             <label className="flex items-start gap-3 cursor-pointer">
//               <input
//                 type="checkbox"
//                 checked={agreedToDisclaimer}
//                 onChange={(e) => setAgreedToDisclaimer(e.target.checked)}
//                 className="mt-1 w-5 h-5 rounded border-[#676DFF] bg-transparent checked:bg-[#676DFF] focus:ring-[#676DFF] cursor-pointer"
//               />
//               <span className="text-white text-sm">
//                 I have read and agree to the disclaimer. I understand that I am using a third-party service 
//                 and acknowledge all associated risks and responsibilities.
//               </span>
//             </label>
//           </div>

//           <div className="flex gap-4">
//             <button
//               onClick={() => setCurrentStep('howto')}
//               disabled={!agreedToDisclaimer}
//               className="flex-1 py-3 bg-[#676DFF] hover:bg-[#5A60E8] disabled:bg-[#505050] disabled:cursor-not-allowed text-white font-medium rounded-lg transition-colors flex items-center justify-center gap-2"
//             >
//               Continue
//               <ArrowRight className="h-4 w-4" />
//             </button>
//           </div>
//         </div>
//       </div>

//       <div className="bg-[#151515] rounded-xl border border-[#676DFF]/20 p-6">
//         <h3 className="text-lg font-medium text-white mb-3 flex items-center gap-2">
//           <Info className="h-5 w-5 text-[#676DFF]" />
//           What happens next?
//         </h3>
//         <ul className="space-y-2 text-sm text-[#B8B8B8]">
//           <li className="flex items-start gap-2">
//             <span className="text-[#676DFF]">1.</span>
//             Review deposit instructions and wallet details
//           </li>
//           <li className="flex items-start gap-2">
//             <span className="text-[#676DFF]">2.</span>
//             Complete KYC verification on PayOnRamp (if not done)
//           </li>
//           <li className="flex items-start gap-2">
//             <span className="text-[#676DFF]">3.</span>
//             Make payment using UPI or bank transfer
//           </li>
//           <li className="flex items-start gap-2">
//             <span className="text-[#676DFF]">4.</span>
//             Receive USDT directly to your wallet (15-30 mins)
//           </li>
//         </ul>
//       </div>
//     </div>
//   );

//   const HowToDepositStep = () => (
//     <div className="space-y-6">
//       <div className="bg-[#151515] rounded-2xl border border-[#676DFF]/20 p-6 lg:p-8">
//         <div className="flex items-start justify-between mb-6">
//           <div>
//             <h2 className="text-2xl font-semibold text-white mb-2">
//               How to Deposit Funds
//             </h2>
//             <p className="text-[#B8B8B8]">
//               Follow these steps to add USDT to your portfolio
//             </p>
//           </div>
//           <button
//             onClick={() => setCurrentStep('disclaimer')}
//             className="text-[#808080] hover:text-white text-sm"
//           >
//             ← Back
//           </button>
//         </div>
        


//         {/* Instructions */}
//         <div className="space-y-4 mb-6">
//           <div className="bg-[#0A0A0A] border border-[#505050] rounded-xl p-6">
//             <h3 className="text-white font-medium mb-4 flex items-center gap-2">
//               <span className="w-8 h-8 bg-[#676DFF] rounded-full flex items-center justify-center text-white font-bold text-sm">1</span>
//               Prepare Two Devices
//             </h3>
//             <p className="text-[#B8B8B8] text-sm mb-2">
//               You will need two devices to complete the payment: one to access PayOnRamp and another to scan the QR code for UPI payment. Make sure to complete the payment using the registered bank account on PayOnRamp.
//             </p>
//             <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-3">
//               <p className="text-blue-400 text-xs">
//                 💡 TIP: Keep your phone ready for scanning the payment QR code
//               </p>
//             </div>
//           </div>

//           <div className="bg-[#0A0A0A] border border-[#505050] rounded-xl p-6">
//             <h3 className="text-white font-medium mb-4 flex items-center gap-2">
//               <span className="w-8 h-8 bg-[#676DFF] rounded-full flex items-center justify-center text-white font-bold text-sm">2</span>
//               Login to PayOnRamp
//             </h3>
//             <p className="text-[#B8B8B8] text-sm">
//               Click the purple "Login/Register" button in the top right corner of the PayOnRamp window.
//             </p>
//           </div>

//           <div className="bg-[#0A0A0A] border border-[#505050] rounded-xl p-6">
//             <h3 className="text-white font-medium mb-4 flex items-center gap-2">
//               <span className="w-8 h-8 bg-[#676DFF] rounded-full flex items-center justify-center text-white font-bold text-sm">3</span>
//               Navigate to Buy/Sell
//             </h3>
//             <p className="text-[#B8B8B8] text-sm">
//               Click on "Buy / Sell" in the navigation menu.
//             </p>
//           </div>

//           <div className="bg-[#0A0A0A] border border-[#505050] rounded-xl p-6">
//             <h3 className="text-white font-medium mb-4 flex items-center gap-2">
//               <span className="w-8 h-8 bg-[#676DFF] rounded-full flex items-center justify-center text-white font-bold text-sm">4</span>
//               Select USDT on Polygon
//             </h3>
//             <p className="text-[#B8B8B8] text-sm mb-2">
//               In the token dropdown, select "USDT on Polygon (MATIC)" or "USDT-POL".
//             </p>
//             <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-lg p-3">
//               <p className="text-yellow-400 text-xs">
//                 ⚠️ CRITICAL: Selecting the wrong token or network will result in permanent loss of funds!
//               </p>
//             </div>
//           </div>

//           <div className="bg-[#0A0A0A] border border-[#505050] rounded-xl p-6">
//             <h3 className="text-white font-medium mb-4 flex items-center gap-2">
//               <span className="w-8 h-8 bg-[#676DFF] rounded-full flex items-center justify-center text-white font-bold text-sm">5</span>
//               Enter Your Wallet Address
//             </h3>
//             <p className="text-[#B8B8B8] text-sm mb-2">
//               Paste your wallet address in the wallet field (copied from above).
//             </p>
//             <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-3">
//               <p className="text-red-400 text-xs">
//                 ⚠️ Double-check the address before proceeding
//               </p>
//             </div>
//           </div>
//         </div>

//                 {/* Your Wallet Address */}
//         {client?.wallet_address && (
//           <div className="bg-[#0A0A0A] border border-[#676DFF]/30 rounded-xl p-6 mb-6">
//             <div className="flex items-start gap-3 mb-4">
//               <Wallet className="h-5 w-5 text-[#676DFF] mt-0.5 flex-shrink-0" />
//               <div className="flex-1">
//                 <h3 className="text-white font-medium mb-2">Your Wallet Address</h3>
//                 <p className="text-[#B8B8B8] text-sm mb-3">
//                   Copy this address to receive USDT
//                 </p>
//                 <div className="flex items-center gap-2">
//                   <code className="text-[#676DFF] text-sm break-all flex-1 bg-[#151515] p-3 rounded-lg border border-[#505050]">
//                     {client.wallet_address}
//                   </code>
//                   <button
//                     onClick={() => copyToClipboard(client.wallet_address, 'wallet')}
//                     className="p-3 bg-[#676DFF] hover:bg-[#5A60E8] rounded-lg transition-colors flex-shrink-0"
//                   >
//                     {showTooltip === 'wallet' ? (
//                       <CheckCircle className="h-5 w-5 text-white" />
//                     ) : (
//                       <Copy className="h-5 w-5 text-white" />
//                     )}
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         <div className="flex gap-4">
//           <a
//             href="https://payonramp.com"
//             target="_blank"
//             rel="noopener noreferrer"
//             className="flex-1 py-3 bg-[#676DFF] hover:bg-[#5A60E8] text-white font-medium rounded-lg transition-colors flex items-center justify-center gap-2"
//           >
//             Go to PayOnRamp
//             <ExternalLink className="h-4 w-4" />
//           </a>
//         </div>
//       </div>

//       <div className="bg-[#151515] rounded-xl border border-[#676DFF]/20 p-6">
//         <h3 className="text-lg font-medium text-white mb-3 flex items-center gap-2">
//           <Info className="h-5 w-5 text-[#676DFF]" />
//           Important Notes
//         </h3>
//         <ul className="space-y-2 text-sm text-[#B8B8B8]">
//           <li className="flex items-start gap-2">
//             <AlertTriangle className="h-4 w-4 text-yellow-400 mt-0.5 flex-shrink-0" />
//             Always verify you're selecting USDT on Polygon network
//           </li>
//           <li className="flex items-start gap-2">
//             <CheckCircle className="h-4 w-4 text-[#676DFF] mt-0.5 flex-shrink-0" />
//             Transactions typically process in 15-30 minutes
//           </li>
//           <li className="flex items-start gap-2">
//             <CheckCircle className="h-4 w-4 text-[#676DFF] mt-0.5 flex-shrink-0" />
//             You can track progress on the PayOnRamp platform
//           </li>
//         </ul>
//       </div>
//     </div>
//   );

//   return (
//     <div style={{ fontFamily: 'Lexend, sans-serif' }}>
//       {currentStep === 'disclaimer' && <DisclaimerStep />}
//       {currentStep === 'howto' && <HowToDepositStep />}
//     </div>
//   );
// };

// export default AddFundsSection;

import React, { useState, useCallback, useEffect, useRef } from 'react';
import { 
  Info, ExternalLink, CheckCircle, AlertTriangle, 
  Copy, Wallet, ArrowRight, Shield, HelpCircle
} from 'lucide-react';

const AddFundsSection = ({ client }) => {
  const [currentStep, setCurrentStep] = useState('disclaimer');
  const [agreedToDisclaimer, setAgreedToDisclaimer] = useState(false);
  const [showTooltip, setShowTooltip] = useState(null);
  
  // Ref for scroll container
  const containerRef = useRef(null);

  // Scroll to top on mount and step change
  useEffect(() => {
    // Scroll the window to top
    window.scrollTo({ top: 0, behavior: 'smooth' });
    
    // Also scroll the container if it exists
    if (containerRef.current) {
      containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [currentStep]);

  // Copy to clipboard helper
  const copyToClipboard = useCallback((text, type) => {
    navigator.clipboard.writeText(text);
    setShowTooltip(type);
    setTimeout(() => setShowTooltip(null), 2000);
  }, []);

  // Tooltip component
  const Tooltip = ({ text, type }) => (
    <div className="relative inline-block ml-2">
      <button
        onMouseEnter={() => setShowTooltip(type)}
        onMouseLeave={() => setShowTooltip(null)}
        className="text-[#808080] hover:text-[#676DFF] transition-colors"
      >
        <HelpCircle className="h-4 w-4" />
      </button>
      {showTooltip === type && (
        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-[#0A0A0A] border border-[#676DFF]/30 rounded-lg text-xs text-white whitespace-nowrap z-10 shadow-lg">
          {text}
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-1">
            <div className="border-4 border-transparent border-t-[#676DFF]/30"></div>
          </div>
        </div>
      )}
    </div>
  );

  const DisclaimerStep = () => (
    <div className="space-y-6">
      <div className="bg-[#151515] rounded-2xl border border-[#676DFF]/20 p-6 lg:p-8">
        <div className="flex items-start gap-4 mb-6">
          <div className="w-12 h-12 bg-[#676DFF]/10 rounded-full flex items-center justify-center flex-shrink-0">
            <Shield className="h-6 w-6 text-[#676DFF]" />
          </div>
          <div>
            <h2 className="text-2xl font-semibold text-white mb-2">
              Important Disclaimer
            </h2>
            <p className="text-[#B8B8B8]">
              Please read carefully before proceeding
            </p>
          </div>
        </div>

        <div className="space-y-6">
          <div className="bg-[#0A0A0A] border border-[#505050] rounded-xl p-6 space-y-4">
            <div className="flex items-start gap-3">
              <AlertTriangle className="h-5 w-5 text-yellow-400 mt-0.5 flex-shrink-0" />
              <div className="space-y-3 text-[#B8B8B8] text-sm leading-relaxed">
                <p>
                  <strong className="text-white">Third-Party Service:</strong> This deposit service is provided by PayOnRamp, 
                  an independent third-party payment processor. AB Nexus acts solely as a facilitator and does not 
                  process, store, or have access to your payment information.
                </p>
                <p>
                  <strong className="text-white">Regulatory Compliance:</strong> By using PayOnRamp, you acknowledge that you 
                  are subject to their terms of service, privacy policy, and KYC requirements. All transactions must comply 
                  with applicable Indian laws and regulations.
                </p>
                <p>
                  <strong className="text-white">No Financial Advice:</strong> The information provided is for informational 
                  purposes only and does not constitute financial, investment, or legal advice. You are solely responsible 
                  for your investment decisions.
                </p>
                <p>
                  <strong className="text-white">Risk Acknowledgment:</strong> Cryptocurrency trading involves substantial 
                  risk of loss. Only invest funds you can afford to lose. Past performance does not guarantee future results.
                </p>
                <p>
                  <strong className="text-white">Liability Limitation:</strong> AB Nexus is not liable for any 
                  issues arising from PayOnRamp's services, including but not limited to payment failures, delays, or disputes. 
                  Please contact PayOnRamp support directly for payment-related issues.
                </p>
                <p>
                  <strong className="text-white">Data Sharing:</strong> Your wallet address will be shared with PayOnRamp 
                  to facilitate the deposit. No other personal data from our platform is transmitted to PayOnRamp.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-[#676DFF]/10 border border-[#676DFF]/20 rounded-xl p-4">
            <label className="flex items-start gap-3 cursor-pointer">
              <input
                type="checkbox"
                checked={agreedToDisclaimer}
                onChange={(e) => setAgreedToDisclaimer(e.target.checked)}
                className="mt-1 w-5 h-5 rounded border-[#676DFF] bg-transparent checked:bg-[#676DFF] focus:ring-[#676DFF] cursor-pointer"
              />
              <span className="text-white text-sm">
                I have read and agree to the disclaimer. I understand that I am using a third-party service 
                and acknowledge all associated risks and responsibilities.
              </span>
            </label>
          </div>

          <div className="flex gap-4">
            <button
              onClick={() => setCurrentStep('howto')}
              disabled={!agreedToDisclaimer}
              className="flex-1 py-3 bg-[#676DFF] hover:bg-[#5A60E8] disabled:bg-[#505050] disabled:cursor-not-allowed text-white font-medium rounded-lg transition-colors flex items-center justify-center gap-2"
            >
              Continue
              <ArrowRight className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>

      <div className="bg-[#151515] rounded-xl border border-[#676DFF]/20 p-6">
        <h3 className="text-lg font-medium text-white mb-3 flex items-center gap-2">
          <Info className="h-5 w-5 text-[#676DFF]" />
          What happens next?
        </h3>
        <ul className="space-y-2 text-sm text-[#B8B8B8]">
          <li className="flex items-start gap-2">
            <span className="text-[#676DFF]">1.</span>
            Review deposit instructions and wallet details
          </li>
          <li className="flex items-start gap-2">
            <span className="text-[#676DFF]">2.</span>
            Complete KYC verification on PayOnRamp (if not done)
          </li>
          <li className="flex items-start gap-2">
            <span className="text-[#676DFF]">3.</span>
            Make payment using UPI or bank transfer
          </li>
          <li className="flex items-start gap-2">
            <span className="text-[#676DFF]">4.</span>
            Receive USDT directly to your wallet (15-30 mins)
          </li>
        </ul>
      </div>
    </div>
  );

  const HowToDepositStep = () => (
    <div className="space-y-6">
      <div className="bg-[#151515] rounded-2xl border border-[#676DFF]/20 p-6 lg:p-8">
        <div className="flex items-start justify-between mb-6">
          <div>
            <h2 className="text-2xl font-semibold text-white mb-2">
              How to Deposit Funds
            </h2>
            <p className="text-[#B8B8B8]">
              Follow these steps to add USDT to your portfolio
            </p>
          </div>
          <button
            onClick={() => setCurrentStep('disclaimer')}
            className="text-[#808080] hover:text-white text-sm"
          >
            ← Back
          </button>
        </div>
        


        {/* Instructions */}
        <div className="space-y-4 mb-6">
          <div className="bg-[#0A0A0A] border border-[#505050] rounded-xl p-6">
            <h3 className="text-white font-medium mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-[#676DFF] rounded-full flex items-center justify-center text-white font-bold text-sm">1</span>
              Prepare Two Devices
            </h3>
            <p className="text-[#B8B8B8] text-sm mb-2">
              You will need two devices to complete the payment: one to access PayOnRamp and another to scan the QR code for UPI payment.
            </p>
            <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-3">
              <p className="text-blue-400 text-xs">
                💡 TIP: Keep your phone ready for scanning the payment QR code
              </p>
            </div>
          </div>

          <div className="bg-[#0A0A0A] border border-[#505050] rounded-xl p-6">
            <h3 className="text-white font-medium mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-[#676DFF] rounded-full flex items-center justify-center text-white font-bold text-sm">2</span>
              Login to PayOnRamp
            </h3>
            <p className="text-[#B8B8B8] text-sm">
              Click the purple "Login/Register" button in the top right corner of the PayOnRamp window.
            </p>
          </div>

          <div className="bg-[#0A0A0A] border border-[#505050] rounded-xl p-6">
            <h3 className="text-white font-medium mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-[#676DFF] rounded-full flex items-center justify-center text-white font-bold text-sm">3</span>
              Navigate to Buy/Sell
            </h3>
            <p className="text-[#B8B8B8] text-sm">
              Click on "Buy / Sell" in the navigation menu.
            </p>
          </div>

          <div className="bg-[#0A0A0A] border border-[#505050] rounded-xl p-6">
            <h3 className="text-white font-medium mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-[#676DFF] rounded-full flex items-center justify-center text-white font-bold text-sm">4</span>
              Select USDT on Polygon
            </h3>
            <p className="text-[#B8B8B8] text-sm mb-2">
              In the token dropdown, select "USDT on Polygon (MATIC)" or "USDT-POL".
            </p>
            <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-lg p-3">
              <p className="text-yellow-400 text-xs">
                ⚠️ CRITICAL: Selecting the wrong token or network will result in permanent loss of funds!
              </p>
            </div>
          </div>

          <div className="bg-[#0A0A0A] border border-[#505050] rounded-xl p-6">
            <h3 className="text-white font-medium mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-[#676DFF] rounded-full flex items-center justify-center text-white font-bold text-sm">5</span>
              Enter Your Wallet Address
            </h3>
            <p className="text-[#B8B8B8] text-sm mb-2">
              Paste your wallet address in the wallet field (This can be found below and in your Profile Settings).
            </p>
            <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-3">
              <p className="text-red-400 text-xs">
                ⚠️ Double-check the address before proceeding
              </p>
            </div>
          </div>
        </div>

                {/* Your Wallet Address */}
        {client?.wallet_address && (
          <div className="bg-[#0A0A0A] border border-[#676DFF]/30 rounded-xl p-6 mb-6">
            <div className="flex items-start gap-3 mb-4">
              <Wallet className="h-5 w-5 text-[#676DFF] mt-0.5 flex-shrink-0" />
              <div className="flex-1">
                <h3 className="text-white font-medium mb-2">Your Wallet Address</h3>
                <p className="text-[#B8B8B8] text-sm mb-3">
                  Copy this address to receive USDT
                </p>
                <div className="flex items-center gap-2">
                  <code className="text-[#676DFF] text-sm break-all flex-1 bg-[#151515] p-3 rounded-lg border border-[#505050]">
                    {client.wallet_address}
                  </code>
                  <button
                    onClick={() => copyToClipboard(client.wallet_address, 'wallet')}
                    className="p-3 bg-[#676DFF] hover:bg-[#5A60E8] rounded-lg transition-colors flex-shrink-0"
                  >
                    {showTooltip === 'wallet' ? (
                      <CheckCircle className="h-5 w-5 text-white" />
                    ) : (
                      <Copy className="h-5 w-5 text-white" />
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="flex gap-4">
          <a
            href="https://payonramp.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 py-3 bg-[#676DFF] hover:bg-[#5A60E8] text-white font-medium rounded-lg transition-colors flex items-center justify-center gap-2"
          >
            Go to PayOnRamp
            <ExternalLink className="h-4 w-4" />
          </a>
        </div>
      </div>

      <div className="bg-[#151515] rounded-xl border border-[#676DFF]/20 p-6">
        <h3 className="text-lg font-medium text-white mb-3 flex items-center gap-2">
          <Info className="h-5 w-5 text-[#676DFF]" />
          Important Notes
        </h3>
        <ul className="space-y-2 text-sm text-[#B8B8B8]">
          <li className="flex items-start gap-2">
            <AlertTriangle className="h-4 w-4 text-yellow-400 mt-0.5 flex-shrink-0" />
            Always verify you're selecting USDT on Polygon network
          </li>
          <li className="flex items-start gap-2">
            <CheckCircle className="h-4 w-4 text-[#676DFF] mt-0.5 flex-shrink-0" />
            Transactions typically process in 15-30 minutes
          </li>
          <li className="flex items-start gap-2">
            <CheckCircle className="h-4 w-4 text-[#676DFF] mt-0.5 flex-shrink-0" />
            You can track progress on the PayOnRamp platform
          </li>
        </ul>
      </div>
    </div>
  );

  return (
    <div ref={containerRef} style={{ fontFamily: 'Lexend, sans-serif' }}>
      {currentStep === 'disclaimer' && <DisclaimerStep />}
      {currentStep === 'howto' && <HowToDepositStep />}
    </div>
  );
};

export default AddFundsSection;